var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$root.profile.role !== 11000)?_c('taskToday3'):_c('taskToday')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }